import styles from '../Header.module.css';
import flame from "@/commons/resources/images/logos/fiamma.png";
import Redirects from "@/commons/utils/Redirects";

const HeaderLogo = ({ redirect }) => {
    return (
        <img
            className={styles.headerLogo}
            src={flame}
            alt="flameLogo"
            onClick={(e) => Redirects.domainSendClick("www", "", e)}
        />
    );
};

export default HeaderLogo;
